import axios from 'axios';

export const verifyRequest = (payload: any) => {
  return axios({
    method: 'POST',
    headers: {
      ['X-Device-Platform']: 'WEB', //eslint-disable-line
    },
    url:
      process.env.REACT_APP_ENV === 'dev'
        ? 'https://api.beta.tipsterchat.com/v1/me/verification'
        : 'https://api.tipsterchat.com/v1/me/verification',
    data: JSON.stringify(payload),
  });
};
export const refreshWallet = () => axios.get('v1/me/wallet');
export const getUserPremiumPlans = (id: string) => {
  return axios.get(`v1/premium/tipsters/${id}/user_plans`);
};

export const resetPasswordRequest = (payload: any) => {
  return axios({
    method: 'PUT',
    headers: {
      ['X-Device-Platform']: 'WEB', //eslint-disable-line
    },
    url:
      process.env.REACT_APP_ENV === 'dev'
        ? 'https://api.beta.tipsterchat.com/v1/me/password'
        : 'https://api.tipsterchat.com/v1/me/password',
    data: JSON.stringify(payload),
  });
};
export const recoverPasswordRequest = (payload: any) => {
  return axios({
    method: 'POST',
    headers: {
      ['X-Device-Platform']: 'WEB', //eslint-disable-line
    },
    url:
      process.env.REACT_APP_ENV === 'dev'
        ? 'https://api.beta.tipsterchat.com/v1/me/password/reset'
        : 'https://api.tipsterchat.com/v1/me/password/reset',
    data: JSON.stringify(payload),
  });
};
export const getCurrent = () => axios.get('v1/me');
export const getMyFlags = () => axios.get('v1/me/flags');
